<template>
  <div class="comments" v-if="proof.proof.comments.length > 0">
    <div
      class="comment badge badge-light text-left mt-5"
      v-for="c of proof.proof.comments"
      :key="c._id"
    >
      <b>{{ getUserName(c.user) }}:</b> <span>{{ c.text }}</span
      ><span class="small text-muted"
        ><br />{{ c.date | moment("D MMM YYYY") }}</span
      >
    </div>
  </div>
</template>
<script>
//import axios from "axios";
export default {
  name: "CommentsChallenge",
  props: {
    proof: Object
  },
  data() {
    return {
      text: ""
    };
  },
  computed: {
    users() {
      return this.$store.getters.getUsers;
    },
    me() {
      return this.$store.getters.getMyUser;
    }
  },
  methods: {
    getUserName(u) {
      let user = this.users.find(user => user._id == u);
      return user.firstName + " " + user.lastName;
    }
  }
};
</script>
<style lang="scss" scoped>
.d-grid {
  display: grid;
  align-items: center;
  &.grid-5 {
    grid-template-columns: repeat(5, 1fr);
  }
  &.grid-2 {
    grid-template-columns: repeat(2, 1fr);
  }
  &.align-items-start {
    align-items: start;
  }
  &.justify-content-end {
    justify-content: flex-end;
  }
  .self-content-end {
    justify-self: flex-end;
  }
}
.bg {
  background: transparent !important;
}
.reverse {
  align-items: flex-end !important;
  .meta {
    flex-direction: row-reverse;
  }
}
</style>
